export default {
  zh: {
    agree: 'Agree',
    reject: 'Reject',
    rejected: 'Rejected',
    agreed: 'Agreed',
    successful: 'The operation was successful',
    initGuild: 'invite you to join his guild',
    doyou: 'Do you agree to become a host of',
    have: 'You have joined another guild'
  },
  en: {
    agree: 'Agree',
    reject: 'Reject',
    rejected: 'Rejected',
    agreed: 'Agreed',
    successful: 'The operation was successful',
    initGuild: 'invite you to join his guild',
    doyou: 'Do you agree to become a host of',
    have: 'You have joined another guild'
  },
  ar: {
    // 阿拉伯
    agree: 'موافق',
    reject: 'رفض',
    rejected: 'رفض',
    agreed: 'وافق',
    successful: 'العملية كانت ناجحه',
    initGuild: 'يدعوك للانضمام الى وكالته',
    doyou: 'هل توافق لتصبح مضيف',
    have: 'لقد انضممت الى وكالة أخرى'
  },
  tr: {
    //土耳其
    agree: 'Kabul Et',
    reject: 'Reddet',
    rejected: 'Reddedilmiş',
    agreed: 'Kabul Edildi',
    successful: 'İşlem Başarılı Oldu',
    initGuild: 'sizi loncasına katılmaya davet ediyor',
    doyou: 'in yayıncısı olmayı kabul ediyor musunuz?',
    have: 'Başka bir loncaya katıldınız'
  },
  uz: {
    agree: 'Rozi',
    reject: 'Rad etish',
    rejected: 'Rad etilgan',
    agreed: "Rozi bo'lingan",
    successful: "Operatsiya muvaffaqiyatli bo'ldi",
    initGuild: "sizi o'z gildiyasiga taklif qiladi",
    doyou: "Sizga mezbon bo'lishga rozi bo'lasizmi",
    have: "Siz boshqa gildiyaga qo'shildingiz"
  },
  ru: {
    agree: 'Согласен',
    reject: 'Отклонить',
    rejected: 'Отклонено',
    agreed: 'Согласовано',
    successful: 'Операция прошла успешно',
    initGuild: 'приглашает вас присоединиться к своей гильдии',
    doyou: 'Вы согласны стать хостом',
    have: 'Вы уже присоединились к другой гильдии'
  },
  fa: {
    agree: 'موافقت',
    reject: 'رد کردن',
    rejected: 'رد شده',
    agreed: 'موافقت شده',
    successful: 'عملیات با موفقیت انجام شد',
    initGuild: 'شما را به پیوستن به گیلد خود دعوت می‌کند',
    doyou: 'آیا موافقید که میزبان شوید',
    have: 'شما به گیلد دیگری پیوسته‌اید'
  },
  pt: {
    agree: 'Concordar',
    reject: 'Rejeitar',
    rejected: 'Rejeitado',
    agreed: 'Concordado',
    successful: 'A operação foi bem-sucedida',
    initGuild: 'o convida para se juntar à sua guilda',
    doyou: 'Você concorda em se tornar um host de',
    have: 'Você já se juntou a outra guilda'
  },
  id: {
    agree: 'Setuju',
    reject: 'Tolak',
    rejected: 'Ditolak',
    agreed: 'Disetujui',
    successful: 'Operasi berhasil',
    initGuild: 'mengundang Anda untuk bergabung dengan guild-nya',
    doyou: 'Apakah Anda setuju untuk menjadi host dari',
    have: 'Anda sudah bergabung dengan guild lain'
  },
  ur: {
    agree: 'قبول کریں',
    reject: 'مسترد کریں',
    rejected: 'مسترد شد',
    agreed: 'قبول شد',
    successful: 'عمل کامیاب رہا',
    initGuild: 'آپ کو اپنی گلڈ میں شامل ہونے کی دعوت دی ہے',
    doyou: 'کیا آپ اس گلڈ کے ہوسٹ بننے پر رضامند ہیں؟',
    have: 'آپ پہلے ہی کسی اور گلڈ میں شامل ہیں'
  }
}



// WEBPACK FOOTER //
// src/pages/app/host-invitation/lang.js